import {createApp} from 'vue'
import options from './PostAside.options'

const el = '.kb-component--post-aside'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((PostAsideDOM)=>{
            const template = PostAsideDOM.outerHTML
            options.template = template
            const component = createApp(options).use(Store)
            component.mount(PostAsideDOM)
        })
    }
}

